import { createAction } from '../helpers';

export const completePayment = createAction('CHECKOUT/COMPLETE_PAYMENT');
export const applyCoupon = createAction('CHECKOUT/APPLY_COUPON');
export const removeCoupon = createAction('CHECKOUT/REMOVE_COUPON');
export const complete = createAction('CHECKOUT/COMPLETE_CHECKOUT');
export const changeCountry = createAction('CHECKOUT/CHANGE_COUNTRY');
export const applyPlan = createAction('CHECKOUT/APPLY_PLAN');
export const load = createAction('CHECKOUT/LOAD');
export const selectPaymentMethod = createAction('CHECKOUT/SELECT_PAYMENT_METHOD');
export const error = createAction('CHECKOUT/ERROR');
export const reset = createAction('CHECKOUT/RESET');
export const close = createAction('CHECKOUT/CLOSE');
